<template>
  <div class="layout-inner pg_inside">

    <navbar></navbar>

    <div class="layout-container">
      <div class="layout-content">

        <template v-if="isLoading">
          <div class="w-100" style="padding: 150px 0;">
            <spinner size="large"></spinner>
          </div>
        </template>
        <template v-else>

          <template v-if="career && career.name">
            <career-title :career="career"></career-title>
          </template>

          <div class="container-fluid flex-grow-1 pg_content_container">
            <div class="row">
              <div class="container ml-3">

                <template v-if="streamsToShow && streamsToShow.length > 0">
                  <template v-for="stream in streamsToShow" v-if="(stream.title || stream.streamTitle)">

                    <div class="row result_row">

                      <div class="col-2 thumbnail_container">
                        <div class="thumbnail_default_name" :style="{background:setThumbnailBgColor(stream.uuid)}">
                          <div class="txt_bx" v-html="setTitleInitials(streamTitle(stream))"></div>
                        </div>
                      </div>

                      <div class="col-10 entity_details">
                        <div class="row">
                          <div class="label" style="width: 95%;">
                            <a class="title" href="javascript://" style="font-size: 16px; margin-left: 6px; display: block; margin-top: 5px;">{{streamTitle(stream)}}</a>
                          </div>
                        </div>
                      </div>

                    </div>

                  </template>
                </template>

                <template v-else class="mt-5">
                  <div class="text-center">
                    <h4>No pathways available for this Career</h4>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </template>

        <career-footer-navbar :pageTitle="'Pathways'" :returnTo="'careerHome'" :params="{isComingFromBookmark: isComingFromBookmark}"></career-footer-navbar>

      </div>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CareerTitle from './CareerTitle'
  import Navbar from '../../misc/components/./Navbar'
  import CareerFooterNavbar from '../../misc/components/./CareerFooterNavbar'
  import VClamp from 'vue-clamp'

  export default {
    name: 'career-pathways',
    props: ['code', 'isComingFromBookmark'],
    components: {
      Navbar,
      CareerTitle,
      CareerFooterNavbar,
      VClamp
    },
    data: () => {
      return {
        isLoading: true
      }
    },

    mounted () {
      this.loadDataForCareerPathways()
    },

    methods: {
      ...mapActions([
        'loadUserObj',
        'loadCareer',
        'loadAlumniStreamRecommendations',
        'loadAdvisorStreamRecommendations'
      ]),
      async loadDataForCareerPathways () {
        await this.loadUserObj()
        await this.loadCareer(this.code)
        let alumniRecommendationData = this.buildAlumniStreamRecommendationData(this.career)
        let advisorRecommendationData = this.buildAdvisorStreamRecommendationData(this.career)
        this.loadAlumniStreamRecommendations({ recommendationData: alumniRecommendationData })
        this.loadAdvisorStreamRecommendations({ recommendationData: advisorRecommendationData })
        this.isLoading = false
      },
      parseTerms (sourceList) {
        if (!sourceList || !sourceList.length) {
          return []
        }
        let targetList = []
        sourceList.forEach((item, i) => {
          let curr = JSON.parse(item)
          targetList.push(curr.name)
        })
        return targetList
      },
      buildAlumniStreamRecommendationData (career) {
        let data = {
          'title': career.name,
          'socCode': career.code,
          'topCompanies': this.parseTerms(career.topPostingCompanies),
          'topSkills': this.parseTerms(career.skills),
          'majors': (career.majors) ? career.majors : [],
          'departments': (career.departments) ? career.departments : [],
          'category': career.category || ''
        }
        return data
      },
      buildAdvisorStreamRecommendationData (career) {
        let data = {
          'requestType': 'career',
          'relatedCipCodes': career.cipCodes
        }
        return data
      },
      streamTitle (stream) {
        let title = (stream.title) ? stream.title : stream.streamTitle
        return title
      },
      setTitleInitials (streamTitle) {
        let getTitleInitials = streamTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      },
      setThumbnailBgColor (entityId) {
        let getNumricValue = entityId.replace(/[^0-9]/g, '')
        return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
      },
      getStreamBookmark (stream) {
        let bookmarks = this.bookmarks
        if (!bookmarks || !bookmarks.length) {
          return false
        }
        let target = false
        bookmarks.forEach(bookmark => {
          if (bookmark.entityUuid === stream.uuid) {
            target = bookmark
          }
        })
        return target
      },
      isBookmarked (stream) {
        return stream.bookmark && stream.bookmark.uuid
      },
      hideUserNamePopup () {
        this.$refs.userNamePopupContainer.$emit('close')
      }
    },
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj,
        'career': state => state.career.careerObject,
        'alumniStreamRecommendations': state => state.stream.alumniStreamRecommendations,
        'advisorStreamRecommendations': state => state.stream.advisorStreamRecommendations,
        'bookmarks': state => state.explore.bookmarks
      }),
      streamsToShow () {
        let advisorStreams = this.advisorStreamRecommendations
        let alumniStreams = this.alumniStreamRecommendations
        let isAdvisorStreamsEmpty = !advisorStreams || !advisorStreams.length
        let isAlumniStreamsEmpty = !alumniStreams || !alumniStreams.length
        if (isAdvisorStreamsEmpty && isAlumniStreamsEmpty) {
          return []
        }
        let streamsToShow = []
        if (!isAdvisorStreamsEmpty) {
          streamsToShow = advisorStreams
        }
        if (!isAlumniStreamsEmpty) {
          streamsToShow = streamsToShow.concat(alumniStreams)
        }
        let getStreamBookmark = this.getStreamBookmark
        streamsToShow.forEach(stream => {
          stream.bookmark = getStreamBookmark(stream)
        })
        return streamsToShow.slice(0, 8)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerPathways.vue